<div class="explorer">
  <img
    src="/images/logo-homebroker.svg"
    alt="GBMhomebroker logo"
    height="30"
    width="199"
    class="login-logo"
  />

  <div class="navegador">Tu navegador no es compatible</div>
  <div class="detail">Pero puedes usar cualquiera de estas opciones:</div>

  <div class="grid-navedadores">
    <div class="grid-image">
      <a
        href="https://www.google.com/chrome/"
        target="_blank"
        rel="noopener noreferrer"
        ><div class="button-icon icon-logo-chrome"></div
      ></a>
    </div>
    <div class="grid-image">
      <a
        href="https://www.mozilla.org/es-MX/firefox/new/"
        target="_blank"
        rel="noopener noreferrer"
        ><div class="button-icon icon-logo-firefox"></div
      ></a>
    </div>
    <div class="grid-image">
      <a
        href="https://support.apple.com/downloads/safari"
        target="_blank"
        rel="noopener noreferrer"
        ><div class="button-icon icon-logo-safari"></div
      ></a>
    </div>
    <div class="grid-image">
      <a
        href=" https://www.opera.com/download"
        target="_blank"
        rel="noopener noreferrer"
        ><div class="button-icon icon-logo-opera"></div
      ></a>
    </div>
    <div class="grid-text">Chrome</div>
    <div class="grid-text">Firefox</div>
    <div class="grid-text">Safari</div>
    <div class="grid-text">Opera</div>
  </div>
</div>
